module.exports = __webpack_public_path__ + "img/s.a7dd62a6.webp";